import { Modal, type ModalProps } from 'antd';
import type { FC } from 'react';

export const AppModal: FC<ModalProps> = (props) => {
  return <Modal {...props} />;
};
